import { background_colors, error_colors, info_colors, success_colors, warning_colors, } from '../commons';
export const zont_colors = (dark) => ({
    primary: {
        light: dark ? '#9efbff' : '#6cedf1',
        main: dark ? '#6ac8cc' : '#2ababe',
        dark: dark ? '#33979b' : '#00898e',
        contrastText: '#f0f0f0',
    },
    secondary: {
        light: '#50b9be',
        main: '#00898e',
        dark: '#005b61',
        contrastText: '#fff',
        // main: dark ? pink[200] : darken(pink.A400, 0.1),
        // light: dark ? '#ff9089' : '#f76354',
        // main: dark ? '#de5f5c' : '#be2f2a',
        // dark: dark ? '#a72e32' : '#860000',
        // contrastText: '#ffffff',
    },
    error: error_colors(dark),
    warning: warning_colors(dark),
    info: info_colors(dark),
    success: success_colors(dark),
    background: background_colors(dark),
});
export const heat_light = {
    primary: {
        light: '#f3994b',
        main: '#f0801e',
        dark: '#a85915',
        contrastText: '#f0f0f0',
    },
    secondary: {
        light: '#4ba4f3',
        main: '#1e8ef0',
        dark: '#1563a8',
        contrastText: '#f0f0f0',
    },
};
export const heat_dark = {
    primary: {
        light: '#a94720',
        main: '#f2662f',
        dark: '#f48458',
        contrastText: '#f0f0f0',
    },
    secondary: {
        light: '#75edff',
        main: '#2fbbf2',
        dark: '#008bbf',
        contrastText: '#f0f0f0',
    },
};
export const car_light = {
    primary: {
        light: '#56c8cb',
        main: '#2cbbbf',
        dark: '#1e8285',
        contrastText: '#0f0f0f',
    },
    secondary: {
        light: '#f86456',
        main: '#bf312c',
        dark: '#870003',
        contrastText: '#f0f0f0',
    },
};
export const car_dark = {
    primary: {
        light: '#47aba2',
        main: '#19978b',
        dark: '#116961',
        contrastText: '#0f0f0f',
    },
    secondary: {
        light: '#cd4e4e',
        main: '#971926',
        dark: '#620000',
        contrastText: '#f0f0f0',
    },
};
export const security = {
    primary: {
        light: '#b5d261',
        main: '#a3c73a',
        dark: '#728b28',
        contrastText: '#0f0f0f',
    },
    secondary: {
        light: '#9267fb',
        main: '#5d3ac7',
        dark: '#1f0c95',
        contrastText: '#f0f0f0',
    },
};
